import React from 'react';
import SectionContainer from '../SectionContainer';
import HomeSlider from '../Slider';

const SectionAnimation = () => {
  return (
    <SectionContainer
      id="animation"
      className="home-animation"
      rootClassName=""
      appearance=""
    >
      <div className="container">
        <img
          src="https://cdn.shopify.com/s/files/1/0631/2017/9426/files/animation.gif"
          alt="Case For Making Marketplace"
        />
      </div>
      <HomeSlider />
    </SectionContainer>
  );
};

export default SectionAnimation;
